import { render, staticRenderFns } from "./IsQRCode.vue?vue&type=template&id=10cbb0ae&"
import script from "./IsQRCode.vue?vue&type=script&lang=js&"
export * from "./IsQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports